
import { CheckCircle, GraduationCap } from 'lucide-react'

export default function GdUniversity() {

    // INFO SUPPLEMENTAIRE  
    const infoSup = [
        {
            title: "Les procédures d'admission ",
            description: "(étapes, documents requis, délais) ",
        },
        {
            title: "Les frais de scolarité et options de paiement Les offres de logement ",
            description: "(campus, partenariat avec des résidences étudiantes) ",
        },
        {
            title: "Les frais de scolarité et options de paiement Les offres de logement ",
            description: "(campus, partenariat avec des résidences étudiantes) ",
        },
        {
            title: "Chaque site est régulièrement mis à jour et constitue une source fiable et complète pour préparer votre inscription. ",
            description: " ",
        },
    ]
    return (
        <>
            <div className="min-h-screen  mtCGfreeUniv dark:bg-gray-900  from-indigo-50 to-purple-50">
                {/* Header */}
                <header className=" dark:bg-gray-900 shadow-sm ">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
                        <GraduationCap className="h-8  w-8 text-green-800 " />
                        <div className="flex  items-center justify-between">
                            <div className="flex dark:bg-gray-900 text items-center space-x-3">
                                <div>
                                    <h1 className="text-2xl font-bold dark:text-gray-100 text-green-800">Universités</h1>
                                    <h2 className="text-gray-400  mt-1">
                                        {/* Découvrez les meilleures universités et leurs programmes d'études  */}
                                        <span className="text-gray-600 font-semibold dark:text-gray-200">Activez votre accès Premium et laissez My Kenya Student Process vous guider à chaque étape de votre parcours universitaire au Kenya</span></h2>
                                </div>
                            </div>

                            {/* <svg xmlns="http://www.w3.org/2000/svg" className="w-8 h-8 dark:text-green-500 text-green-500 stroke-current" fill="none" viewBox="0 0 24 24" strokeWidth="1.5"><path strokeLinecap="round" strokeLinejoin="round" d="M12 6L20 9l-8 3-8-3 8-3z" /><path strokeLinecap="round" strokeLinejoin="round" d="M12 6v12" /><path strokeLinecap="round" strokeLinejoin="round" d="M20 12a8.1 8.1 0 01-8 8 8.1 8.1 0 01-8-8" /></svg> */}

                            {/* <div className="hidden md:flex items-center space-x-2">
              <div className="w-8 h-5 bg-black"></div>
              <div className="w-8 h-5 bg-red-600"></div>
              <div className="w-8 h-5 bg-green-600"></div>
            </div> */}
                        </div>
                    </div>
                </header>

                <section className="max-w-7xl  -mt-10 mx-auto px-4 sm:px-6 lg:px-8 py-8">
                    <div className="p-6 dark:text-gray-300 mt-10 rounded-lg bg-white dark:bg-gray-800 border border-gray-200  dark:border-gray-700">
                        <h3 className=" mb-4  flex items-center">
                            Il existe de nombreuses autres universités au Kenya qui pourraient convenir selon votre domaine d'étude, votre budget ou vos préférences. Toutefois, celles que nous avons sélectionnées ici sont parmi les plus reconnues, les plus fréquentées par les étudiant e e•s internationaux et celles offrant un bon cadre de vie et d'étude.
                        </h3>
                        <h3 className=" mb-4  flex items-center">
                            Besoin d'aide ou de plus d'informations ? Notre équipe est là pour vous accompagner à chaque étape de votre projet d'études au Kenya. Que ce soit pour poser une question, clarifier une procédure, ou obtenir un soutien personnalisé, n'hésitez pas à nous contacter !
                        </h3>
                    </div>
                    <section className="py-12 px-6 mt-5 dark:bg-gray-800 border rounded-lg dark:border-gray-700 md:px-20 bg-gray-100">
                        <div className="max-w-6xl mx-auto text-center">
                            <h2 className="text-2xl font-bold dark:text-gray-100 text-gray-800 mb-8">Explorer les Universités</h2>

                            <div className="grid grid-cols-1  md:grid-cols-3 gap-8">
                                <a
                                    href="/mksp/guide/all-university"
                                    className="text-green-600 font-medium hover:text-door"
                                >
                                    <div className="bg-white dark:bg-gray-800  rounded-xl shadow-lg p-6 hover:shadow-xl transition-all duration-300">
                                        <h3 className="text-xl font-semibold text-green-700 mb-2">Toutes les Universités</h3>
                                        <p className="text-5xl font-bold text-green-800 dark:text-gray-200 mb-4">±20</p>

                                        Voir toutes les universités →

                                    </div>
                                </a>


                                <a
                                    href="/mksp/guide/university-public"
                                    className="text-blue-600 font-medium hover:text-door"
                                >
                                    <div className="bg-white dark:bg-gray-800  rounded-xl shadow-lg p-6 hover:shadow-xl transition-all duration-300">
                                        <h3 className="text-xl font-semibold text-blue-700 mb-2">Universités Publiques</h3>
                                        <p className="text-5xl font-bold text-blue-800 dark:text-gray-200 mb-4">±5</p>

                                        Voir les universités publiques →
                                    </div>
                                </a>

                                <a
                                    href="/mksp/guide/university-private"
                                    className="text-purple-600 font-medium hover:text-door"
                                >
                                    <div className="bg-white dark:bg-gray-800  rounded-xl shadow-lg p-6 hover:shadow-xl transition-all duration-300">
                                        <h3 className="text-xl font-semibold text-purple-700 mb-2">Universités Privées</h3>
                                        <p className="text-5xl font-bold text-purple-700 dark:text-gray-200 mb-4">±15</p>

                                        Voir les universités privées →
                                    </div>
                                </a>
                            </div>
                        </div>
                    </section>
                    <div className="grid grid-cols-1 mt-5 lg:grid-cols-2 gap-6">
                        {infoSup.map((option, index) => (
                            <div key={index} className="p-6 rounded-lg dark:bg-gray-800 bg-white border-gray-200 border dark:border-gray-700">
                                <div className="flex items-center  space-x-3 mb-4">
                                    <h3 className=" font-semibold">{option.title}</h3>
                                </div>
                                <ul className="space-y-3">
                                    <li className="flex items-start space-x-2">
                                        <CheckCircle className="h-4 w-4 text-green-600 mt-0.5 flex-shrink-0" />
                                        <span className="text-sm dark:text-gray-300 text-gray-700">{option.description}</span>
                                    </li>
                                </ul>
                            </div>
                        ))}
                    </div>
                </section>
            </div>
        </>
    )
}
